var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6666 22.963V26.6667C22.6666 28.8758 24.4575 30.6667 26.6666 30.6667H29.3333C31.5424 30.6667 33.3333 28.8758 33.3333 26.6667V22.963L29.6245 24.6113C28.5903 25.071 27.4097 25.071 26.3754 24.6113L22.6666 22.963ZM36.6666 21.4815V27.3333C36.6666 27.8856 37.1143 28.3333 37.6666 28.3333C38.2189 28.3333 38.6666 27.8856 38.6666 27.3333V20.5913C38.6545 20.5976 38.642 20.6035 38.6292 20.6092L36.6666 21.4815Z",
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.3707 19.3908L26.3754 15.3887C27.4097 14.929 28.5903 14.929 29.6245 15.3887L38.6293 19.3908C39.1571 19.6254 39.1571 20.3746 38.6293 20.6092L29.6245 24.6113C28.5903 25.071 27.4097 25.071 26.3754 24.6113L17.3707 20.6092C16.8428 20.3746 16.8428 19.6254 17.3707 19.3908Z",
    fill: "#1C0054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.0661 32.5328L28.948 34.6746C28.4261 35.2023 27.5738 35.2023 27.0519 34.6746L24.9339 32.5328C24.6067 32.202 24.1291 32.061 23.6826 32.1922C19.9425 33.2921 17.3333 35.7772 17.3333 38.6667C17.3333 40.1395 18.5272 41.3334 20 41.3334H36C37.4727 41.3334 38.6666 40.1395 38.6666 38.6667C38.6666 35.7772 36.0575 33.2921 32.3173 32.1922C31.8709 32.061 31.3932 32.202 31.0661 32.5328Z",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentType);
export default __webpack_public_path__ + "static/media/student-type.129864247aff6d31e666c84def64fd47.svg";
export { ForwardRef as ReactComponent };